import { Layout, defaultGrid } from './layout';
import { jsx as _jsx } from "react/jsx-runtime";
export { Layout };
export function LayoutContainer(_ref) {
  let {
    height,
    width,
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(Layout, {
    showBorder: true,
    width: width,
    height: height,
    hasSubtitle: true,
    gridTemplate: defaultGrid,
    ...props,
    children: children
  });
}